import { __awaiter } from "tslib";
import { text, phone, isValidInput } from "@phoenixreisen/form";
import { resetPhxPasswordViaSMS } from "../model";
import m from "mithril";
const Link = m.route.Link;
const reset = (state, e) => __awaiter(void 0, void 0, void 0, function* () {
    const { username, phone } = state.fields;
    e.preventDefault();
    if (isValidInput(state.fields)) {
        state.error = null;
        state.submitting = true;
        yield resetPhxPasswordViaSMS(username.value(), phone.value())
            .then(() => m.route.set("/zurueckgesetzt/sms"))
            .catch((result) => {
            state.error = result;
            state.submitting = false;
            m.redraw();
        });
    }
});
export default class {
    oninit({ state }) {
        state.error = null;
        state.submitting = false;
        state.fields = {
            username: text(true, (input) => {
                state.error = null;
                return input;
            }),
            phone: phone(true, (input) => {
                state.error = null;
                return input;
            }),
        };
    }
    view({ state }) {
        const { fields, error, submitting } = state;
        const { username, phone } = fields;
        return (m("form", { class: "form login-form pa2", onsubmit: (e) => reset(state, e) },
            m("p", null, "Sofern deine Mobilnummer in der Datenbank hinterlegt ist, bekommst du ein neues Passwort per SMS zugeschickt."),
            error && (m("div", { class: "alert alert--danger" }, error["userfriendly-message"] ||
                error["details"] ||
                `Dein Passwort konnte nicht zurückgesetzt werden. Bitte
                        prüfe deine Eingabe und melde dich im Zweifel bei der IT`)),
            m("div", null,
                m("label", { class: "textfield" },
                    m("input", { type: "text", name: "username", maxLength: "100", autocomplete: "username", placeholder: "z.B. Fabian", value: username.value(), oninput: (e) => username.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${username.complaint ? "alert--warning" : ""}` }, "Dein Benutzername")),
                m("label", { class: "textfield" },
                    m("input", { type: "number", name: "phone", maxLength: "13", autocomplete: "phone", placeholder: "z.B. 01633060439", value: phone.value(), oninput: (e) => phone.validate(e.target.value) }),
                    m("span", { class: `textfield__label ${phone.complaint ? "alert--warning" : ""}` }, "Deine Mobilnummer"))),
            m("div", { class: "flex justify-between items-center" },
                m("button", { type: "submit", disabled: submitting, class: "ma0" },
                    submitting ? m("i", { class: "fas fa-spinner fa-spin mr2" }) : "",
                    m("span", { class: "desktop-only" }, "Passwort"),
                    " zur\u00FCcksetzen"),
                m(Link, { href: "/", title: "zur\u00FCck zur Anmeldung", class: "btn btn--link ma0 ml2" },
                    m("i", { class: "fas fa-home mr1" }),
                    " Login"))));
    }
}
